var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMultiColorFire = function SvgMultiColorFire(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 25 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FF4B4B",
    d: "M21.218 14.44c0 4.728-4.063 8.56-9.075 8.56s-9.075-3.832-9.075-8.56c0-5.427 6.02-11.18 8.254-13.129a1.24 1.24 0 0 1 1.643 0c2.233 1.949 8.253 7.703 8.253 13.13"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#FCD97D",
    d: "M16.273 16.842c0 2.186-1.85 3.957-4.131 3.957S8.01 19.028 8.01 16.842c0-2.509 2.74-5.169 3.758-6.07a.56.56 0 0 1 .747 0c1.017.902 3.758 3.562 3.758 6.07"
  })));
};
export { SvgMultiColorFire as ReactComponent };